import React, { useEffect, useState } from "react";
import {
  getDisplayRanking,
  updateDisplayRanking,
} from "services/locationService";
import * as Sentry from "@sentry/react";

const DisplayLocationRankingToggle = ({ locationId }) => {
  const [displayRanking, setDisplayRanking] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const value = await getDisplayRanking(locationId);
        setDisplayRanking(value);
      } catch (error) {
        Sentry.captureException(error);
        console.error("Erreur de récupération:", error);
      } finally {
        setLoading(false);
      }
    };

    if (locationId) fetchSetting();
  }, [locationId]);

  const handleToggle = async () => {
    try {
      const newValue = !displayRanking;
      setDisplayRanking(newValue);
      await updateDisplayRanking(locationId, newValue);
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur de mise à jour:", error);
      alert("La mise à jour a échoué.");
    }
  };

  if (loading) return <p className="text-white">Chargement...</p>;

  return (
    <div className="flex items-center space-x-2 text-white p-2">
      <input
        type="checkbox"
        id="displayRanking"
        checked={displayRanking}
        onChange={handleToggle}
        className="form-checkbox h-5 w-5 text-amber-500"
      />
      <label htmlFor="displayRanking" className="text-lg font-bold">
        Afficher les classements
      </label>
    </div>
  );
};

export default DisplayLocationRankingToggle;
